import createCache from '@emotion/cache';

export const muiCache = createCache({
  key: 'tin',
  prepend: true,
});
